module.exports = __webpack_public_path__ + "img/Hatchback_Side_Right.b53b03d7.svg";